/* eslint-disable no-mixed-operators */
/* eslint-disable no-case-declarations */
import React from 'react';

export const LineEndType = {
    NONE: 'none',           // 无箭头
    TRIAGNLE: 'triangle',   // 三角形箭头
    ARROW: 'arrow',         // 开放型箭头
    STEALTH: 'stealth',     // 燕尾箭头
    DIAMOND: 'diamond',     // 钻石
    OVAL: 'oval',           // 圆形
};

export const LineEndWidthType = {
    SMALL: 'sm',
    MIDDLE: 'med',
    LARGE: 'lg',
};

export type ILineEndType = typeof LineEndType[keyof typeof LineEndType];

export type IEndInfo = {
    lengthType?: typeof LineEndWidthType[keyof typeof LineEndWidthType];
    widthType?: typeof LineEndWidthType[keyof typeof LineEndWidthType];
    lineEndType: ILineEndType;
};
interface StrokeData {
    strokeColor: string;
    opacity: number;
    strokeWidth: number;
}

// 以下所有strokeDasharray='100%'为了解决safari下首尾两端会继承其形状的dashArray，在有些虚线在箭头显示不全
export default class LineEndBaseStyle {
    public static endWidthOfLineWidth = (endType: string, lengthType: string, lineWidth: number): number => {
        switch (endType) {
            case LineEndType.TRIAGNLE:
            case LineEndType.STEALTH:
                return this.getMultipleTimes(lengthType) * lineWidth * 2 / 3;
            case LineEndType.ARROW:
                return this.getMultipleTimes(lengthType) * lineWidth / 12;
            case LineEndType.DIAMOND:
            case LineEndType.OVAL:
            case LineEndType.NONE:
            default:
                return 0;
        }
    };

    public static renderEnd = (
        lineWidth: number,
        strokeData: StrokeData,
        refId: string,
        endInfo: IEndInfo,
    ): React.ReactElement => {
        const { widthType, lengthType, lineEndType } = endInfo;
        const widthTimes = LineEndBaseStyle.getMultipleTimes(widthType);
        const lengthTimes = LineEndBaseStyle.getMultipleTimes(lengthType);

        switch (lineEndType) {
            case LineEndType.TRIAGNLE:
                return (
                    <marker
                        id={refId}
                        markerWidth={3 * lineWidth}
                        markerHeight={3 * lineWidth}
                        refX={(lengthTimes / 3) * lineWidth}
                        refY={(widthTimes / 2) * lineWidth}
                        orient={'auto-start-reverse'}
                        markerUnits={'userSpaceOnUse'}
                    >
                        <path
                            fill={strokeData.strokeColor}
                            fillOpacity={strokeData.opacity}
                            strokeDasharray={'100%'}
                            d={
                                `M${0} ${0} `
                                + `L ${lengthTimes * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + `L ${0} ${widthTimes * lineWidth} `
                                + 'Z'
                            }
                        />
                    </marker>
                );
            case LineEndType.ARROW: {
                const width = strokeData.strokeWidth;
                return (
                    <marker
                        id={refId}
                        markerWidth={6 * lineWidth}
                        markerHeight={6 * lineWidth}
                        refX={lengthTimes * lineWidth}
                        refY={(widthTimes / 2) * lineWidth}
                        orient={'auto-start-reverse'}
                        markerUnits={'userSpaceOnUse'}
                    >
                        <path
                            stroke={strokeData.strokeColor}
                            strokeOpacity={strokeData.opacity}
                            strokeWidth={width}
                            strokeDasharray={'100%'}
                            strokeLinecap={'round'}
                            fill={'none'}
                            d={
                                `M${0} ${0} `
                                + `L ${lengthTimes * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + `L ${0} ${widthTimes * lineWidth}`
                            }
                        />
                    </marker>
                );
            }
            case LineEndType.STEALTH:
                return (
                    <marker
                        id={refId}
                        markerWidth={3 * lineWidth}
                        markerHeight={3 * lineWidth}
                        refX={(lengthTimes / 3) * lineWidth}
                        refY={(widthTimes / 2) * lineWidth}
                        orient={'auto-start-reverse'}
                        markerUnits={'userSpaceOnUse'}
                    >
                        <path
                            fill={strokeData.strokeColor}
                            fillOpacity={strokeData.opacity}
                            strokeDasharray={'100%'}
                            d={
                                `M${0} ${0} `
                                + `L ${lengthTimes * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + `L ${0} ${widthTimes * lineWidth} `
                                + `L ${(lengthTimes / 3) * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + 'Z'
                            }
                        />
                    </marker>
                );
            case LineEndType.DIAMOND:
                return (
                    <marker
                        id={refId}
                        markerWidth={3 * lineWidth}
                        markerHeight={3 * lineWidth}
                        refX={0}
                        refY={(widthTimes / 2) * lineWidth}
                        orient={'auto-start-reverse'}
                        markerUnits={'userSpaceOnUse'}
                    >
                        <path
                            fill={strokeData.strokeColor}
                            fillOpacity={strokeData.opacity}
                            strokeDasharray={'100%'}
                            d={
                                `M${0} ${0} `
                                + `L ${(lengthTimes / 2) * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + `L ${0} ${widthTimes * lineWidth} `
                                + `L ${-(lengthTimes / 2) * lineWidth} ${(widthTimes / 2) * lineWidth} `
                                + 'Z'
                            }
                        />
                    </marker>
                );
            case LineEndType.OVAL:
                const radiusX = (lengthTimes / 2) * lineWidth;
                const radiusY = (widthTimes / 2) * lineWidth;
                return (
                    <marker
                        id={refId}
                        markerWidth={3 * lineWidth}
                        markerHeight={3 * lineWidth}
                        refX={0}
                        refY={0}
                        orient={'auto-start-reverse'}
                        markerUnits={'userSpaceOnUse'}
                    >
                        <path
                            fill={strokeData.strokeColor}
                            fillOpacity={strokeData.opacity}
                            strokeDasharray={'100%'}
                            d={
                                `M${-radiusX} ${0} `
                                + `A${radiusX},${radiusY} 0 1,0 ${radiusX},${0}`
                                + `A${radiusX},${radiusY} 0 1,0 ${-radiusX},${0}`
                            }
                        />
                    </marker>
                );
            case LineEndType.NONE:
            default:
                return <marker id={refId} />;
        }
    };

    private static getMultipleTimes(endWidthType?: string): number {
        // 获取不同箭头粗细对应的几倍线宽
        switch (endWidthType) {
            case LineEndWidthType.SMALL:
                return 2;
            case LineEndWidthType.LARGE:
                return 5;
            case LineEndWidthType.MIDDLE:
            default:
                return 3;
        }
    }
}
